import { Outlet } from 'react-router-dom';
import styles from './admin.module.scss';
function AdminConsole(){

  return(
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Outlet/>
      </div>
    </div>
  );
}

export default AdminConsole;